import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AuthProvider } from './contexts/AuthContext';
render(<BrowserRouter data-id="element-1210">
    <AuthProvider data-id="element-1211">
      <App data-id="element-1212" />
    </AuthProvider>
  </BrowserRouter>, document.getElementById('root'));